/**
 * Modular PDP — symptom photo review gallery tabs + video lightbox.
 * Init via [data-modular-pdp-symptom-review]. No optional chaining.
 */
(function (doc, win) {
  'use strict';

  var lightboxEl = null;
  var lightboxVideo = null;
  var lastFocus = null;
  var scrollY = 0;

  function activate(root, key) {
    if (!root || !key) return;

    var tabs = root.querySelectorAll('[data-symptom-tab]');
    var panels = root.querySelectorAll('[data-symptom-panel]');
    var statEl = root.querySelector('[data-symptom-stat-display]');
    var i;

    for (i = 0; i < tabs.length; i++) {
      var tab = tabs[i];
      var isActive = tab.getAttribute('data-symptom-tab') === key;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive && statEl && tab.getAttribute('data-symptom-stat')) {
        statEl.textContent = tab.getAttribute('data-symptom-stat');
      }
    }

    for (i = 0; i < panels.length; i++) {
      var panel = panels[i];
      var show = panel.getAttribute('data-symptom-panel') === key;
      panel.classList.toggle('is-active', show);
      if (show) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    }

    // Recalc carousel widths after a previously-hidden panel becomes visible
    if (win && typeof win.dispatchEvent === 'function') {
      win.dispatchEvent(new Event('resize'));
    }
  }

  function ensureLightbox() {
    if (lightboxEl) return lightboxEl;

    lightboxEl = doc.createElement('div');
    lightboxEl.className = 'modular-pdp-symptom-review__lightbox';
    lightboxEl.setAttribute('role', 'dialog');
    lightboxEl.setAttribute('aria-modal', 'true');
    lightboxEl.setAttribute('aria-label', 'Customer video review');
    lightboxEl.hidden = true;
    lightboxEl.innerHTML =
      '<div class="modular-pdp-symptom-review__lightbox-backdrop" data-symptom-video-close></div>' +
      '<div class="modular-pdp-symptom-review__lightbox-dialog">' +
      '<button type="button" class="modular-pdp-symptom-review__lightbox-close" data-symptom-video-close aria-label="Close video">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<video class="modular-pdp-symptom-review__lightbox-video" controls playsinline></video>' +
      '</div>';

    doc.body.appendChild(lightboxEl);
    lightboxVideo = lightboxEl.querySelector('.modular-pdp-symptom-review__lightbox-video');

    lightboxEl.addEventListener('click', function (e) {
      var t = e.target;
      if (!t) return;
      // Click may land on SVG/path inside the close button — walk up
      var closeHit = typeof t.closest === 'function'
        ? t.closest('[data-symptom-video-close]')
        : null;
      if (closeHit) {
        e.preventDefault();
        closeLightbox();
      }
    });

    return lightboxEl;
  }

  function lockScroll() {
    scrollY = win.pageYOffset || doc.documentElement.scrollTop || 0;
    doc.body.style.position = 'fixed';
    doc.body.style.top = '-' + scrollY + 'px';
    doc.body.style.left = '0';
    doc.body.style.right = '0';
    doc.body.style.width = '100%';
  }

  function unlockScroll() {
    doc.body.style.position = '';
    doc.body.style.top = '';
    doc.body.style.left = '';
    doc.body.style.right = '';
    doc.body.style.width = '';
    win.scrollTo(0, scrollY);
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      closeLightbox();
    }
  }

  function openLightbox(src, poster) {
    if (!src) return;
    ensureLightbox();
    lastFocus = doc.activeElement;

    lightboxVideo.pause();
    lightboxVideo.removeAttribute('src');
    while (lightboxVideo.firstChild) {
      lightboxVideo.removeChild(lightboxVideo.firstChild);
    }

    var source = doc.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    lightboxVideo.appendChild(source);
    if (poster) {
      lightboxVideo.setAttribute('poster', poster);
    } else {
      lightboxVideo.removeAttribute('poster');
    }
    lightboxVideo.load();

    lightboxEl.hidden = false;
    lightboxEl.classList.add('is-open');
    lockScroll();
    doc.addEventListener('keydown', onKeydown);

    var playPromise = lightboxVideo.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }

    var closeBtn = lightboxEl.querySelector('.modular-pdp-symptom-review__lightbox-close');
    if (closeBtn && typeof closeBtn.focus === 'function') {
      closeBtn.focus();
    }
  }

  function closeLightbox() {
    if (!lightboxEl || lightboxEl.hidden) return;

    if (lightboxVideo) {
      lightboxVideo.pause();
      lightboxVideo.removeAttribute('src');
      while (lightboxVideo.firstChild) {
        lightboxVideo.removeChild(lightboxVideo.firstChild);
      }
      lightboxVideo.load();
    }

    lightboxEl.classList.remove('is-open');
    lightboxEl.hidden = true;
    doc.removeEventListener('keydown', onKeydown);
    unlockScroll();

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
    }
    lastFocus = null;
  }

  function bindVideoTriggers(root) {
    var triggers = root.querySelectorAll('[data-symptom-video-open]');
    Array.prototype.forEach.call(triggers, function (btn) {
      if (btn.dataset.symptomVideoBound === 'true') return;
      btn.dataset.symptomVideoBound = 'true';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openLightbox(
          btn.getAttribute('data-video-src'),
          btn.getAttribute('data-video-poster')
        );
      });
    });
  }

  function playInlineVideo(video) {
    if (video.dataset.symptomVideoLoaded !== 'true') {
      video.dataset.symptomVideoLoaded = 'true';
      var source = video.querySelector('source[data-src]');
      if (source) {
        source.src = source.getAttribute('data-src');
        video.load();
      }
    }
    video.muted = true;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  // Hidden tab panels and off-screen carousel slides never intersect, so they stay unloaded.
  function bindLazyVideos(root) {
    var videos = root.querySelectorAll('[data-symptom-lazy-video]');
    if (!videos.length) return;

    if (!('IntersectionObserver' in win)) {
      Array.prototype.forEach.call(videos, playInlineVideo);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          playInlineVideo(video);
        } else if (video.dataset.symptomVideoLoaded === 'true') {
          video.pause();
        }
      });
    }, { rootMargin: '200px 0px' });

    Array.prototype.forEach.call(videos, function (video) {
      observer.observe(video);
    });
  }

  function bindQuoteToggles(root) {
    var quotes = root.querySelectorAll('[data-symptom-quote-toggle]');
    Array.prototype.forEach.call(quotes, function (quote) {
      if (quote.dataset.symptomQuoteBound === 'true') return;
      quote.dataset.symptomQuoteBound = 'true';

      function toggleQuote() {
        var expanded = quote.classList.toggle('is-expanded');
        quote.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        var card = typeof quote.closest === 'function'
          ? quote.closest('.modular-pdp-symptom-review__card')
          : null;
        if (card) {
          card.classList.toggle('is-quote-expanded', expanded);
        }
      }

      quote.addEventListener('click', function () {
        toggleQuote();
      });

      quote.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
          e.preventDefault();
          toggleQuote();
        }
      });
    });
  }

  function init(root) {
    if (!root || root.dataset.symptomGalleryInit === 'true') return;
    root.dataset.symptomGalleryInit = 'true';
    bindLazyVideos(root);

    var tabs = root.querySelectorAll('[data-symptom-tab]');
    if (!tabs.length) return;

    Array.prototype.forEach.call(tabs, function (tab) {
      tab.addEventListener('click', function () {
        activate(root, tab.getAttribute('data-symptom-tab'));
      });
    });

    var defaultKey = root.getAttribute('data-default-key') || tabs[0].getAttribute('data-symptom-tab');
    activate(root, defaultKey);
    bindVideoTriggers(root);
    bindQuoteToggles(root);
  }

  function initAll() {
    Array.prototype.forEach.call(
      doc.querySelectorAll('[data-modular-pdp-symptom-review]'),
      init
    );
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})(document, window);
